import { Common } from '@stockbit/ui';
import moment from 'moment';

import If from 'global/ErrorHandlers/If';

import { useBondPortfolioStore } from '../../stores/useBondPortfolioStore';
import { BondInfoType } from '../../constants';
import {
  ModalBody,
  ModalContainer,
  ModalHeader,
  ModalRoot,
} from '../../styled';

import { Container } from './styled';
import InfoContent from './infoContent';
import { useBondInfoModal } from '../../stores/useBondInfoModal';

const { Flex, Iconmoon, Text } = Common;

export default function ModalBondInformation() {
  const [modalInfoType, closeInfoModal] = useBondInfoModal((s) => [
    s.modalInfoType,
    s.closeInfoModal,
  ]);

  const portfolioProduct = useBondPortfolioStore((s) => s.product);

  const { content, title } = InfoContent[modalInfoType];

  return (
    <ModalRoot
      visible={modalInfoType !== BondInfoType.UNSPECIFIED}
      onCancel={closeInfoModal}
      zIndex={2000}
    >
      <ModalContainer>
        <ModalHeader>
          <Flex justify="between" align="center" w="100%">
            <Text
              family="bold"
              size="18px"
              mt="0"
              width="100%"
              data-cy="bonds-modal-header"
              align="center"
            >
              {title}
            </Text>
            <Iconmoon
              className="icon-trading_x"
              color="#333333"
              size="12px"
              onClick={closeInfoModal}
            />
          </Flex>
        </ModalHeader>
        <ModalBody
          css={`
            width: 375px;
          `}
        >
          <Container>
            {content.map((item, i) => (
              <p key={`content-item-${i + 1}`}>
                {item}
                <If condition={modalInfoType === BondInfoType.PROJECTED_RETURN}>
                  {' '}
                  {moment(portfolioProduct?.meta?.maturity_date).format(
                    'DD MMMM YYYY',
                  )}
                </If>
              </p>
            ))}
          </Container>
        </ModalBody>
      </ModalContainer>
    </ModalRoot>
  );
}
